import React from 'react';
import { Link } from 'react-router';
import Moment from 'moment';
import { Helmet } from 'react-helmet';
import Api from '../../api/api';
import AppStore from '../../stores/stores';
import AuthMixin from '../../mixins/authenticationMixin';
import AppRoutes from '../../routes/routes';
import './bookmarks-marketing.scss';
import DataError from '../../components/errors/data-error';
import CustomSelect from '../../components/custom-elements/custom-select';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';

class BookmarksMarketing extends React.Component {
  constructor() {
    super();
    this.state = {
      noData: false,
      bookmarks: [],
      error: false,
      sortBy: ''
    }
  }

  componentDidMount() {
    this._onChange();
  }

  _onChange(cb) {
    AppStore.getBookmarks(this.props.userApiRequest, {
      onSuccess: ({ data }) => {
        this.setState({
          bookmarks: this.sortByDate(data),
          noData: (data.length) ? false : true
        });
      },
      onError: () => this.setState({ error: true })
    });
  }

  handleChange(e) {
    var targetValue = '';

    if (Api.selectorMatches(e.currentTarget, 'li')) {
      targetValue = e.currentTarget.textContent;
    } else if (Api.selectorMatches(e.currentTarget, 'select')) {
      targetValue = e.currentTarget.value;
    }

    if (targetValue !== this.state.sortBy) {
      const firstChar = targetValue.charAt(0).toUpperCase();
      const reminderChars = targetValue.substring(1);
      var data = [];
      if (typeof (this[`sortBy${firstChar}${reminderChars}`]) == 'function') {
        data = this[`sortBy${firstChar}${reminderChars}`](this.state.bookmarks)
      }

      this.setState({
        sortBy: targetValue,
        bookmarks: (data.length ? data : this.state.bookmarks)
      })
    }
  }

  removeBookmark({ title }, e) {
    const target = e.target;

    AppStore.removeBookmark(title, this.props.userApiRequest, {
      onSuccess: ({ data }) => {
        const animations = [
          { 'transform': 'translateX(0) scale(1)', 'visibility': 'visible' },
          { 'transform': 'translateX(-1000px) scale(0)', 'visibility': 'hidden' }
        ];
        Api.animateElement(target.parentNode, animations, () => {
          this._onChange();
          PostHogService.capture(PostHogEvents.BOOKMARK_REMOVED, {
            title: title,
            source: 'bookmarks_page'
          });
        });
      },
      onError: () => { }
    });
  }

  sortByAlphabet(data) {
    return data.sort((a, b) => {
      if (a.title.charAt(0) > b.title.charAt(0)) {
        return 1
      }
      if (a.title.charAt(0) < b.title.charAt(0)) {
        return -1;
      }
      return 0;
    })
  }

  sortByDate(data) {
    return data.sort((a, b) => {
      if (new Date(a.created_at) < new Date(b.created_at)) {
        return 1
      } else if (new Date(a.created_at) > new Date(b.created_at)) {
        return -1;
      } else {
        return 0;
      }
    })
  }

  bookmarks() {
    return this.state.bookmarks.map((bookmark, index) => {
      return (
        <div key={index} className="bookmark-item">
          <div className="bookmark-content">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="var(--blue-100)" stroke="var(--blue-600)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: '2px' }}><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>
            <div className="text">
              <p className="title">
                <Link
                  to={`${AppRoutes.checklists}${bookmark.checklist_slug}`}
                  className="bookmark"
                  title={bookmark.title}
                  onClick={() => PostHogService.capture(PostHogEvents.BOOKMARK_CLICKED, { checklist_id: bookmark.checklist_slug, title: bookmark.title })}
                >
                  {bookmark.title}
                </Link>
              </p>
              <span className="bookmark-date">{`Bookmarked on ${Moment(bookmark.created_at).format('MMMM D, YYYY')}`}</span>
            </div>
          </div>
          <button className="remove-button tooltip-container" onClick={this.removeBookmark.bind(this, bookmark)} title="Remove bookmark">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
          </button>
        </div>
      )
    })
  }

  render() {
    if (this.state.error) return <DataError />

    let bookmarks = this.bookmarks();
    if (this.state.noData) {
      bookmarks = (<div className="no-bookmarks"><p>You don't currently have any bookmarks. Use the Bookmark icon on a checklist to save it here for later.</p></div>)
    }

    return (
      <div className="marketing-checklist-page">
        <Helmet>
          <title>Neurochecklists | Bookmarks</title>
        </Helmet>

        <header className="m-checklist-header pure-g">
          <div className="inner-container inner-container--wide pure-u-1">
            <div className="header-top">
              <div>
                <h1>Your Bookmarks</h1>
                <p className="last-updated">Quickly access the checklists you've saved</p>
              </div>
            </div>
          </div>
        </header>

        <div className="checklist-content">
          <div className="main-content">
            <div className="bookmarks-sort-bar" id="custom-element" onClick={this.handleChange.bind(this)}>
              <span className="bookmarks-sort-label">Sort by:</span>
              <div className="custom-select-holder">
                <CustomSelect
                  handleChange={(e) => this.handleChange(e)}
                  default={'date'}
                  options={{
                    date: 'Date',
                    alphabet: 'Alphabet'
                  }}
                />
              </div>
            </div>

            <div className="bookmarks-container">
              {bookmarks}
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default AuthMixin(BookmarksMarketing);
